import React, { memo, useMemo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import ReactionChip from './components/ReactionChip';
import { rootStyles } from './TeamChatReactions.styles';
import { groupReactions } from './TeamChatReactions.utils';

const TeamChatReactions = memo(({ reactions = [], currentChatUserId = null, onToggle = null }) => {
  const groups = useMemo(() => groupReactions(reactions), [reactions]);

  if (!groups.length) {
    return null;
  }

  return (
    <Box sx={rootStyles}>
      {groups.map(group => (
        <ReactionChip
          count={group.count}
          emoji={group.emoji}
          isOwn={!!currentChatUserId && group.chatUserIds.includes(currentChatUserId)}
          key={group.emoji}
          onToggle={onToggle}
        />
      ))}
    </Box>
  );
});
TeamChatReactions.propTypes = {
  currentChatUserId: PropTypes.string,
  reactions: PropTypes.arrayOf(PropTypes.object),
  onToggle: PropTypes.func,
};

export default TeamChatReactions;
